import * as yup from 'yup';
var Validation = /** @class */ (function () {
    function Validation() {
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: yup.object({
                isAssistanceNeeded: yup.boolean().optional(),
                isDeveloperAvailable: yup.boolean().optional(),
                isMembershipOffering: yup.boolean().optional(),
                isShoppingCartAvailable: yup.boolean().optional(),
                shoppingCart: yup.string().optional(),
                isCashierSystemAvailable: yup.boolean().optional(),
                cashierSystem: yup.string().optional(),
                isPCICompliant: yup.boolean().optional(),
                pciCompliantCertificate: yup.string().optional(),
                isPCICompliantPaymentGatewayUsed: yup.boolean().optional(),
                pciCompliantPaymentGateway: yup.string().optional()
            })
        });
    }
    return Validation;
}());
export { Validation };
